/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_NextInputs */

const en_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const es_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const fr_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const de_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const ja_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次へ`)
};

const zh_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一步`)
};

const ar_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التالي`)
};

const id_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjut`)
};

const it_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanti`)
};

const ru_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далее`)
};

const pt_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const ko_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Action_NextInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_next = /** @type {((inputs?: Action_NextInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_NextInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_next(inputs)
	if (locale === "es") return es_action_next(inputs)
	if (locale === "fr") return fr_action_next(inputs)
	if (locale === "de") return de_action_next(inputs)
	if (locale === "ja") return ja_action_next(inputs)
	if (locale === "zh") return zh_action_next(inputs)
	if (locale === "ar") return ar_action_next(inputs)
	if (locale === "id") return id_action_next(inputs)
	if (locale === "it") return it_action_next(inputs)
	if (locale === "ru") return ru_action_next(inputs)
	if (locale === "pt") return pt_action_next(inputs)
	return ko_action_next(inputs)
});